module.exports = __webpack_public_path__ + "static/media/filter.c3e646d0.svg";